import { useCallback, useEffect, useState } from 'react';
import { DataState } from '@betty/toolkit/state';
import { logError } from '@betty/toolkit/logging';
import { InteracEmailVerification } from '../state/payment/payment.types';
import PaymentService from '../services/PaymentService/PaymentService';

const useEmailVerification = (token: string) => {
  const [data, setData] = useState<InteracEmailVerification>();
  const [dataState, setDataState] = useState<DataState>('idle');

  const verify = useCallback(async () => {
    try {
      setDataState('pending');

      const data = await PaymentService.verifyInteracEmail({
        data: { token },
      });

      setData(data);
      setDataState('fulfilled');
    } catch (error) {
      logError('Verify Interac email request failure.', error);
      setDataState('rejected');
    }
  }, [token]);

  useEffect(() => {
    verify();
  }, [verify]);

  return { data, dataState };
};

export default useEmailVerification;
